import Vue from 'vue';
import Vuetify from 'vuetify';
import VeeValidate from 'vee-validate';
import Toasted from 'vue-toasted';

import App from './App.vue';
import router from './router';
import store from './store';
import NoNavigation from '@/components/layout/NoNavigation.vue';
import HouseholdAdmin from '@/components/layout/HouseholdAdmin.vue';

Vue.component('no-navigation-layout', NoNavigation);
Vue.component('household-admin-layout', HouseholdAdmin);

Vue.config.productionTip = false

Vue.use(Toasted, { position: 'bottom-right', duration: 3000, theme: 'bubble' });
Vue.use(VeeValidate);
Vue.use(Vuetify);

new Vue({
  router,
  store,
  vuetify: new Vuetify(),
  render: h => h(App),
}).$mount('#app')
